import React, {useState} from 'react';
import styles from './admin-transfer-details-modal-content.module.scss';
import { Row, Col, Button, Spinner } from 'react-bootstrap';
import SuccessModalContent
  from "../../../../../securities/security-details/components/modal-content-success/modal-content-success";
import {
  TRANSFER_COMPLETE_ERROR,
  TRANSFER_COMPLETE_SUCCESS,
  TRANSFER_COMPLETED
} from "../../../../../../helpr/constants";
import ErrorModalContent
  from "../../../../../securities/security-details/components/modal-content-error/modal-content-error";
import {toCurrency} from "../../../../../../helpr/helper";
import SecondaryMarketService from "../../../../../../services/secondary-market-service";
import RejectTransferModalContent from "../reject-transfer-modal-content/reject-transfer-modal-content";
import {getGraduatedTaxStatusTypes, getTaxStatusTypes} from "../../../../../../helpr/transferFormData";

const AdminTransferDetailsModalContent = ({context, onClose}) => {
  const SUCCESS_TITLE = "TRANSFER COMPLETED";
  const ERROR_TITLE = "A PROBLEM OCCURRED";
  const [ loading, setLoading ] = useState(false);
  const [ page, setPage ] = useState(0);

  const secondaryMarketService = new SecondaryMarketService();
  const { selectedTransfer, setTransferList } = context;
  const [ transfer, setTransfer ] = useState(selectedTransfer.current);

  const complete = async () => {
    setLoading(true)
    try {
      await secondaryMarketService.completeTransfer(transfer.transferId);
      setTransferList(prev => {
        const updatedList = prev.map(p => {
          if(p.transferId === transfer.transferId){
            return {
              ...p,
              transferStatus: TRANSFER_COMPLETED
            }
          }
          return p
        });
        return updatedList;
      });
      setPage(1)
    }catch(error){
      setPage(2)
    }finally{
      setLoading(false);
    }
  }

  const renderModalPanel = () => {
    switch(page){
      case 1:
        return <SuccessModalContent title={SUCCESS_TITLE} message={TRANSFER_COMPLETE_SUCCESS} onClose={onClose}/>
      case 2:
        return <ErrorModalContent title={ERROR_TITLE} message={TRANSFER_COMPLETE_ERROR} onClose={onClose}/>
      case 3:
        return <RejectTransferModalContent context={context} onBack={() => setPage(0)} onClose={onClose} />
      default:
    }
  }

  const renderTaxStatusValue = key => getTaxStatusTypes().filter(t => t.value === key)[0]?.name;
  const renderGradTaxStatusValue = key => getGraduatedTaxStatusTypes().filter(t => t.value === key)[0]?.name;

  return page === 0 ? (
    <div className={styles['admin-transfer-details-modal-content']}>
      <Row>
        <Col lg={12}>
          <div>
            <Row>
              <Col lg={6} className={styles['label']}>Bond Holder</Col>
              <Col lg={6} className={styles['value']}>
                { transfer.title ? transfer.title : transfer.salutation }{' '}
                {`${transfer.firstName} ${transfer.middleName} ${transfer.lastName}`}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Email Address</Col>
              <Col lg={6} className={styles['value']}>{transfer.emailAddress}</Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Security Name</Col>
              <Col lg={6} className={styles['value']}>{transfer.securityName}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Security ID/ISIN</Col>
              <Col lg={6} className={styles['value']}>{transfer.securityId}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Order Amount (in figure)</Col>
              <Col lg={6} className={styles['value']}>{toCurrency(transfer.transferAmount)}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Order Amount (in words)</Col>
              <Col lg={6} className={styles['value']}>-</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Purchase Date</Col>
              <Col lg={6} className={styles['value']}>
                {transfer.purchaseDate ? transfer.purchaseDate : '-' }
              </Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Tax Status</Col>
              <Col lg={6} className={styles['value']}>{renderTaxStatusValue(transfer.taxStatus)}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Graduated Tax Status</Col>
              <Col lg={6} className={styles['value']}>
                {transfer.graduatedTaxStatus ? renderGradTaxStatusValue(transfer.graduatedTaxStatus) : '-'}
              </Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Broker Name</Col>
              <Col lg={6} className={styles['value']}>{transfer.brokerName}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Transfer Date</Col>
              <Col lg={6} className={styles['value']}>{transfer.transferDate}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Settlement Date</Col>
              <Col lg={6} className={styles['value']}>{transfer.settlementDate}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Registry BP ID</Col>
              <Col lg={6} className={styles['value']}>{transfer.fromRegistryBpId}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Account Number</Col>
              <Col lg={6} className={styles['value']}>{transfer.fromRegistryAccountNumber}</Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>To</Col>
              <Col lg={6} className={styles['value']}>{transfer.toType}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Depository BP ID</Col>
              <Col lg={6} className={styles['value']}>{transfer.toDepositoryBpId}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Account Number</Col>
              <Col lg={6} className={styles['value']}>{transfer.toDepositoryAccountNumber}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Registry BP ID</Col>
              <Col lg={6} className={styles['value']}>{transfer.toRegistryBpId}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Account Number</Col>
              <Col lg={6} className={styles['value']}>{transfer.toRegistryAccountNumber}</Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Non-Stock/Non-Profit</Col>
              <Col lg={6} className={styles['value']}>{transfer.nonStockProfit}</Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Tax Status</Col>
              <Col lg={6} className={styles['value']}>{renderTaxStatusValue(transfer.toTaxStatus)}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Graduated Tax Status</Col>
              <Col lg={6} className={styles['value']}>
                {transfer.toGraduatedTaxStatus ? renderGradTaxStatusValue(transfer.toGraduatedTaxStatus) : '-' }
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      {transfer.transferStatus === '2' ? (
        <>
          <Row className={styles['button-row']}>
            <Col xs={12} lg={4}>
              <div className={styles['close-button']}>
                <Button variant="secondary" onClick={() => onClose()}>
                  CLOSE
                </Button>
              </div>
            </Col>
            <Col xs={12} lg={4}>
              <div className={styles['reject-button']}>
                <Button variant="danger" onClick={() => setPage(3)}>
                  REJECT
                </Button>
              </div>
            </Col>
            <Col xs={12} lg={4}>
              <div className={styles['complete-button']}>
                <Button disabled={loading} onClick={() => complete()}>
                  {loading ? <Spinner size="sm" animation="border"/> : 'COMPLETE'}
                </Button>
              </div>
            </Col>
          </Row>
        </>
      ) : ''}
    </div>
  ) : renderModalPanel();
}

export default AdminTransferDetailsModalContent;
